(function() {
    'use strict';

    angular.module('app').directive('fodbzLabel', FodbzLabelDirective);
    function FodbzLabelDirective() {
        return {
            transclude: true,
            scope: {
                fodbzField: '@',
                fodbzResource: '@',
                fodbzClass: '@'
            },
            template: `<div class="form-group">
                <label for="{{fodbzField}}" class="control-label {{fodbzClass}}">{{fodbzResource}}</label>
                <ng-transclude></ng-transclude>
            </div>`
        };
    }
})();